// extracted by mini-css-extract-plugin
module.exports = {"view":"NewView_style_view__1RJp6","header":"NewView_style_header__1lAIj","title":"NewView_style_title__HCAL6","content":"NewView_style_content__5B2ze"};